"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REPORTDETAILS_SELECT_REPORT = exports.REPORTDETAILS_SELECT_REPORT = "reportDetails/SELECT_REPORT";
var REPORTDETAILS_UPDATE_REPORT = exports.REPORTDETAILS_UPDATE_REPORT = "reportDetails/UPDATE_REPORT";
var REPORTDETAILS_UPDATE_REPORT_SUCCESS = exports.REPORTDETAILS_UPDATE_REPORT_SUCCESS = "reportDetails/UPDATE_REPORT_SUCCESS";
var REPORTDETAILS_UPDATE_REPORT_FAILED = exports.REPORTDETAILS_UPDATE_REPORT_FAILED = "reportDetails/UPDATE_REPORT_FAILED";
var REPORTDETAILS_UPDATE_DISMISS_ERROR = exports.REPORTDETAILS_UPDATE_DISMISS_ERROR = "reportDetails/UPDATE_DISMISS_ERROR";
var REPORTDETAILS_UPDATE_REPORT_FORM_DATA = exports.REPORTDETAILS_UPDATE_REPORT_FORM_DATA = "reportDetails/UPDATE_REPORT_FORM_DATA";
var REPORTDETAILS_UPDATE_REPORT_APP_DATA_FIELD = exports.REPORTDETAILS_UPDATE_REPORT_APP_DATA_FIELD = "reportDetails/UPDATE_REPORT_APP_DATA_FIELD";
var REPORTDETAILS_REPORTSTEP_VALIDATION_CHANGED = exports.REPORTDETAILS_REPORTSTEP_VALIDATION_CHANGED = "reportDetails/REPORTSTEP_VALIDATION_CHANGED";
var REPORTDETAILS_REPORT_CONTINGENT = exports.REPORTDETAILS_REPORT_CONTINGENT = "reportDetails/REPORT_CONTINGENT";
var REPORTDETAILS_REPORT_CONTINGENT_SUCCESS = exports.REPORTDETAILS_REPORT_CONTINGENT_SUCCESS = "reportDetails/REPORT_CONTINGENT_SUCCESS";
var REPORTDETAILS_REPORT_CONTINGENT_FAILED = exports.REPORTDETAILS_REPORT_CONTINGENT_FAILED = "reportDetails/REPORT_CONTINGENT_FAILED";
var REPORTDETAILS_RESET = exports.REPORTDETAILS_RESET = "reportDetails/RESET";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/reducers/reportDetail/constants.ts
 ** module id = 332
 ** module chunks = 0
 **/